import { render, staticRenderFns } from "./CustomSlug.vue?vue&type=template&id=1c1e86ac&"
import script from "./CustomSlug.vue?vue&type=script&lang=ts&"
export * from "./CustomSlug.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports